import { NavLink } from "react-router-dom";

export default function NewsItem({ article, size }) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <>
      <div className="flex flex-col items-start ">
        <NavLink
          to={`/news/` + article?.slug}
          className="relative w-full md:pt-0 pt-60 bg-no-repeat bg-center bg-cover md:bg-none"
          style={{
            backgroundImage: `url(${article?._embedded["wp:featuredmedia"][0]?.source_url})`,
          }}
        >
          <div className="overflow-hidden md:block hidden h-full">
            <img
              src={article?._embedded["wp:featuredmedia"][0]?.source_url}
              alt={article?.title?.rendered}
              className={`min-h-52 w-auto aspect-[16/9] bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2] transition duration-700 ease-in-out transform hover:scale-110`}
            />
          </div>

          {size === "large" && (
            <div className="absolute top-0 left-0 bg-[#58b947] py-2 px-6 text-lg font-medium">
              <span className="text-white">
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      new Date(article.date).getDate() +
                      " " +
                      monthNames[new Date(article.date).getMonth()] +
                      " " +
                      new Date(article.date).getFullYear(),
                  }}
                />
              </span>
            </div>
          )}
        </NavLink>
        <div className="max-w-xl">
          <div className="relative">
            {size === "normal" && (
              <div className="text-lg mt-4 mb-2 text-[#58b947] font-medium">
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      new Date(article.date).getDate() +
                      " " +
                      monthNames[new Date(article.date).getMonth()] +
                      " " +
                      new Date(article.date).getFullYear(),
                  }}
                />
              </div>
            )}
            <h3
              className={`${
                size === "large"
                  ? "font-medium md:text-4xl text-2xl mt-4"
                  : "font-normal md:text-2xl text-lg"
              }`}
            >
              <NavLink to={`/news/` + article?.slug}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: article?.title?.rendered,
                  }}
                />
              </NavLink>
            </h3>
          </div>
        </div>
      </div>
    </>
  );
}
